module.exports = __webpack_public_path__ + "img/tuvalu.aaf8baef.svg";